export default __webpack_public_path__ + "static/media/IMG_0669.dfd1349f.dfd1349f.JPG";